import * as ActionTypes from "../../Actions/DriverLog/ActionTypes"

export const getDriverLogAction = (data) => {
    return {type: ActionTypes.GET_DRIVER_LOG, data};
};
export const getDriverLogSuccessAction = (res) => {
    return {type: ActionTypes.GET_DRIVER_LOG_SUCCESS, res};
};
export const getDriverLogFailAction = (error) => {
    return {type: ActionTypes.GET_DRIVER_LOG_FAIL, error};
};